/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpClient } from '@angular/common/http';
import { inject, Injectable} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TenantService } from '@src/app/shared/tenant.service';

@Injectable({
    providedIn: 'root'
})
export class OurAppTrackerService {

    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private http = inject(HttpClient);    

    private events: string[] = [];

    private reloading = false;

    constructor() {
        this.setUp();
    }

    logCount() {
        return this.events.length;
    }

    getEvents() {
        return [...this.events];
    }
    getVisitUrl() {
        return TenantService.bareAjaxPath + 'pageVisit';
    }

    private getRoutePattern(route: any): string {
        let currentRoute = route;
        const segments: string[] = [];

        // Traverse up the route tree until the root or a componentless route
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
        }

        // Traverse up from the leaf to the root, collecting segments
        while (currentRoute) {
            // routeConfig contains the defined route, e.g., 'user/:id'
            const path = currentRoute.routeConfig?.path;

            if (path && path.length > 0) {
                segments.unshift(path); // Add path to the beginning of the array
            }
            currentRoute = currentRoute.parent;
        }

        // Join and format the final pattern
        return '/' + segments.join('/');
    }

    postPageVisit() { // Don't need any response, ignore any error, usually is 419 error after navigating in expired session
        /* Turning off pageVisit for now, it causes an issue with tests (419)
        and I'm not sure it's providing much value. 
        We can always add it back later if we want to track page visits more robustly.

        const data = {page: this.getRoutePattern(this.activatedRoute.snapshot)};
        this.http.post(this.getVisitUrl(), data).pipe(catchError( () => of(null))).subscribe();
        */
    }
    
    getUrl(evt: NavigationStart|NavigationEnd) {
        return '['+evt.url+']';
    }

    isReloading() {
        return this.reloading;
    }

    reloadPage(url?: string) {
        this.reloading = true;
        if (url) {
            window.location.href = url;
        } else {
            window.location.reload();
        }
        
    }

    setUp() {
        this.router.events.subscribe( (evt) => {
            if (evt instanceof NavigationStart) {
                this.events.unshift('Navigating to ' + this.getUrl(evt));
            }
            if (evt instanceof NavigationEnd) {
                this.postPageVisit()

                if (this.events[0].indexOf(this.getUrl(evt)) > 0) {
                    this.events[0] += ' SUCCEEDED ' + new Date().toISOString();
                } else {
                    this.events.unshift('Navigated to ' + this.getUrl(evt));
                }
            }
        });
    }

    logAction(action)  {
        this.events.unshift(action);
    }
    private saveMsg(title) {
        return 'Saving ' + title;
    }

    startSave(title) {
        this.events.unshift(this.saveMsg(title))
    }

    completeSave(title, success: boolean) {
        if (this.events[0] === this.saveMsg(title)) {
            this.events[0] = this.saveMsg(title) + (success ? ' SUCCEEDED' : ' FAILED') + new Date().toISOString();
        } else {
            this.events.unshift(this.saveMsg(title) + (success ? ' SUCCEEDED' : ' FAILED') + new Date().toISOString());
        }
    }

    printEvents() {
        return "<br/>\n<br/>" + this.events.join("<br/>\n");
    }
}
